module.exports = __webpack_public_path__ + "img/asteroid.4843afc0.png";